import { LinkLegal } from "../interfaces/orden.interface";
import { isValidHttpsUrl } from "./validateUrl";

const escapeHtml = (value: string): string =>
  value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');

export const replaceLegalLinks = (text: string, links?: LinkLegal[]): string => {
  return text.replace(/\{(\d+)\}/g, (_, index) => {
    const link = links?.[Number(index)];

    //* Si no existe el enlace asociado, eliminar marcador
    if (!link) return '';

    const safeLabel = escapeHtml(link.label);

    //* Si la URL no es https, mostrar sólo la etiqueta
    if (!isValidHttpsUrl(link.url)) return safeLabel;

    const safeUrl = escapeHtml(new URL(link.url).href);

    //* Texto transformado para el componente actual
    return `<a href="${safeUrl}" target="_blank" rel="noopener noreferrer">${safeLabel}</a>`;
  });
};
